import interactiveVideoIdentitySelector from './interactive_video_identity_selector'
import interactiveVideoCreateSelector from './interactive_video_create_selector'
import interactiveVideoOeqSubmissionSelector from './interactive_video_oeq_submission_selector'
import interactiveVideoMcqSubmissionSelector from './interactive_video_mcq_submission_selector'
import interactiveVideoMcqShareSolution from './interactive_video_mcq_share_solution'
import interactiveVideoOeqShareParticipantSubmission from './interactive_video_oeq_share_participant_submission'
import interactiveVideoParticipantOeqActivityUidsSelector from './interactive_video_oeq_participant_activities_uids_selector'
import interactiveVideoParticipantMcqActivityUidsSelector from './interactive_video_mcq_participant_activities_uids_selector'
import interactiveVideoSessionTypeSelector from './interactive_video_session_type_selector'
import interactiveVideoCaptionsSelector from './captions_selector'
import interactiveVideoStudentPacedSelector from './interactive_video_student_paced_selector'

export default {
	interactiveVideoIdentitySelector,
	interactiveVideoCreateSelector,
	interactiveVideoOeqSubmissionSelector,
	interactiveVideoMcqSubmissionSelector,
	interactiveVideoMcqShareSolution,
	interactiveVideoOeqShareParticipantSubmission,
	interactiveVideoParticipantOeqActivityUidsSelector,
	interactiveVideoParticipantMcqActivityUidsSelector,
	interactiveVideoCaptionsSelector,
	interactiveVideoSessionTypeSelector,
	interactiveVideoStudentPacedSelector,
}
